// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const OverlayIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="OverlayIcon" ref={forwardedRef} {...props}>
      <path d="M4 15.5h.571V17H3.5l-.103-.005a1 1 0 0 1-.892-.893L2.5 16v-1H4z" />
      <path d="M8.5 17h-2v-1.5h2z" />
      <path d="M16.603 3.005A1 1 0 0 1 17.5 4v12l-.005.102a1 1 0 0 1-.893.893L16.5 17H11V3h5.5zM12.5 15.5H16v-11h-3.5z" />
      <path d="M4 13H2.5v-2H4z" />
      <path d="M4 9H2.5V7H4z" />
      <path d="M4.571 4.5H4V5H2.5V4a1 1 0 0 1 .897-.995L3.5 3h1.071z" />
      <path d="M8.5 4.5h-2V3h2z" />
    </SvgIcon>
  );
});

/**
 * Use to switch to the overlay
 * @public
 */
export const OverlayIcon = /* @__PURE__ */ Object.assign(OverlayIconComponent, {
  displayName: 'OverlayIcon',
});
